import type { ValidationResultItem } from "@/types/types";
import { VALIDATION_RESULT_ITEM_TYPE } from "../types/enums";

export default function ServerResponse({ items }: { items: ValidationResultItem[] | null }) {
  function getColor(type: VALIDATION_RESULT_ITEM_TYPE) {
    switch (type) {
      case VALIDATION_RESULT_ITEM_TYPE.Error:
        return "#FB5555";
      case VALIDATION_RESULT_ITEM_TYPE.Warning:
        return "#14213D";
      default:
        return "";
    }
  }

  return (
    <div className="flex flex-col">
      {items !== null ? (
        <div>
          {items.map((item: ValidationResultItem) => (
            <div key={item.message} style={{ color: getColor(item.type) }} className={`text-base`}>
              {item.message}{" "}
              {item.type === VALIDATION_RESULT_ITEM_TYPE.Error ? (
                <span>Correct and submit again.</span>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
